import { useVistaFeatureFlag } from '@99designs/experiments';

export function useLogoTouchUpFeatureFlag(esMpvId: string) {
    return useVistaFeatureFlag('design_services_logo_touch_up', [
        { value: esMpvId.toLowerCase(), must: 'prologotouchupandcompletion' },
    ]);
}
